module.exports = {
  "zones": {
    "Asia/Atyrau": ["z", {
      "wallclock": 1099191600000,
      "format": "+05",
      "abbrev": "+05",
      "offset": 18000000,
      "posix": 1099173600000,
      "save": 0
    }, {
      "wallclock": 922586400000,
      "format": "+04/+05",
      "abbrev": "+05",
      "offset": 14400000,
      "posix": 922568400000,
      "save": 3600000,
      "rules": "RussiaAsia"
    }, {
      "wallclock": 695786400000,
      "format": "+05/+06",
      "abbrev": "+05",
      "offset": 18000000,
      "posix": 695772000000,
      "save": 0,
      "rules": "RussiaAsia"
    }, {
      "wallclock": 670384800000,
      "format": "+04/+05",
      "abbrev": "+05",
      "offset": 14400000,
      "posix": 670366800000,
      "save": 3600000,
      "rules": "RussiaAsia"
    }, {
      "wallclock": 386467200000,
      "format": "+05/+06",
      "abbrev": "+06",
      "offset": 18000000,
      "posix": 386445600000,
      "save": 3600000,
      "rules": "RussiaAsia"
    }, {
      "wallclock": 370742400000,
      "format": "+06",
      "abbrev": "+06",
      "offset": 21600000,
      "posix": 370724400000,
      "save": 0
    }, {
      "wallclock": -1247529600000,
      "format": "+05",
      "abbrev": "+05",
      "offset": 18000000,
      "posix": -1247540400000,
      "save": 0
    }, {
      "wallclock": -1441152000000,
      "format": "+03",
      "abbrev": "+03",
      "offset": 10800000,
      "posix": -1441164464000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 12464000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "RussiaAsia": [{
      "from": 1985,
      "to": 2010,
      "month": 2,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1996,
      "to": 2010,
      "month": 9,
      "day": [0, -31],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1984,
      "to": 1995,
      "month": 8,
      "day": [0, -30],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1981,
      "to": 1984,
      "month": 3,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1981,
      "to": 1983,
      "month": 9,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }]
  }
};